import React from 'react'

const Imprint = () => {
  const footerIcon = require('assets/images/footerIcon.png')
  return (
    <div className='footer-main-con'>
      <img className='footer-mian-top-icon' src={footerIcon}></img>
      <div>
        <div className='footer-main-top-title'>版权说明</div>
        <p>服务提供方:</p>
        <p>汉高（中国）投资有限公司</p>
        <p>注册地址：中国上海市杨浦区江湾城路99号7幢1层</p>
        <p>联络地址：中国上海市杨浦区江湾城路99号7幢（邮编：200438）</p>
        <p>登记机关：上海市市场监督管理局</p>
        <p>统一社会信用代码：913100001017820211</p>
        <p>邮箱地址：<a href="mailto:corpcomm.hap@henkel.com" target="_blank">corpcomm.hap@henkel.com</a></p>
      </div>
    </div>
  )
}
export default Imprint